export const environment = {
  production: false,
  apiHost: '/api',
  wxappid: 'wxea40ef7232d4001f', //开放平台
  wxauthurl: 'https://www.universalbus.cn/api/user/wxauth',
  open: '/open',
  imgUrl: 'https://testc.universalbus.cn',
};
